import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OnlineSignupState {
  selectedPlanName: any;
  selectedEmployerName: any;
}

const initialState: OnlineSignupState = {
  selectedPlanName: null,
  selectedEmployerName: null,
};

const onlineSignupSlice = createSlice({
  name: "onlineSignup",
  initialState,
  reducers: {
    setSelectedPlanName: (state, action: PayloadAction<string>) => {
      state.selectedPlanName = action.payload;
    },
    setSelectedEmployerName: (state, action: PayloadAction<string>) => {
      state.selectedEmployerName = action.payload;
    },
  },
});

export const { setSelectedPlanName, setSelectedEmployerName } =
  onlineSignupSlice.actions;

export default onlineSignupSlice.reducer;
